import type { EntityType } from '../types/api';

/**
 * Maps entity types to Brazilian Portuguese display labels
 */
export const ENTITY_LABELS: Record<EntityType, string> = {
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  RG: 'RG',
  CEP: 'CEP',
  PHONE_BR: 'TELEFONE',
  EMAIL: 'EMAIL',
  PERSON: 'PESSOA',
  ADDRESS: 'ENDEREÇO',
  CNH: 'CNH',
  MRZ: 'MRZ',
  PIS: 'PIS/NIS',
  TITULO_ELEITOR: 'TÍTULO DE ELEITOR',
  CNS: 'CARTÃO SUS',
  PASSAPORTE: 'PASSAPORTE',
  CTPS: 'CTPS',
  CERTIDAO: 'CERTIDÃO',
  MATRICULA: 'MATRÍCULA',
  VEICULO: 'VEÍCULO',
  BANCO: 'DADOS BANCÁRIOS',
  CARTAO: 'CARTÃO',
  NASCIMENTO: 'NASCIMENTO',
  IP: 'IP',
  REGISTRO_PROFISSIONAL: 'REGISTRO PROFISSIONAL',
  SAUDE: 'SAÚDE',
};

/**
 * Returns the Portuguese display label for an entity type
 */
export function getEntityLabel(type: EntityType): string {
  return ENTITY_LABELS[type] || type;
}
